import { forwardRef } from 'react';

import { Box } from '../../box';

export const DateRangePickerWrapper = forwardRef<
  HTMLDivElement,
  React.PropsWithChildren
>((props: React.PropsWithChildren, ref) => (
  <Box
    ref={ref}
    sx={{
      display: 'flex',
      flex: 1,

      '.MuiMultiInputDateRangeField-root, .MuiMultiInputDateTimeRangeField-root':
        {
          alignItems: 'flex-start',
          flex: 1,
        },

      '.MuiFormControl-hideLabel .MuiFormLabel-root': {
        visibility: 'hidden',
        height: 0,
        width: 0,
      },

      '.MuiFormControl-mediumInputSize': {
        '&.MuiFormControl-hasLabel + .MuiMultiInputDateRangeField-separator, &.MuiFormControl-hasLabel + .MuiMultiInputDateTimeRangeField-separator':
          {
            marginTop: '40px',
          },
        '&.MuiMultiInputDateRangeField-separator, &.MuiFormControl-hideLabel + .MuiMultiInputDateRangeField-separator, &.MuiMultiInputDateTimeRangeField-separator, &.MuiFormControl-hideLabel + .MuiMultiInputDateTimeRangeField-separator':
          {
            marginTop: '18px',
          },
      },
      '.MuiFormControl-defaultInputSize': {
        '&.MuiFormControl-hasLabel + .MuiMultiInputDateRangeField-separator, &.MuiFormControl-hasLabel + .MuiMultiInputDateTimeRangeField-separator':
          {
            marginTop: '30px',
          },
        '&.MuiMultiInputDateRangeField-separator, &.MuiFormControl-hideLabel + .MuiMultiInputDateRangeField-separator, &.MuiMultiInputDateTimeRangeField-separator, &.MuiFormControl-hideLabel + .MuiMultiInputDateTimeRangeField-separator':
          {
            marginTop: '10px',
          },
      },
    }}
    {...props}
  />
));
